import { shape, number, string, oneOf, oneOfType, arrayOf } from 'prop-types';

export const lineItemType = shape({
  quantity: oneOfType([string, number]),
  product_name: string,
  image_urls: shape({
    original: string,
    medium: string,
    thumb: string,
  }),
});

export const shipmentType = shape({
  external_account_id: oneOfType([string, number]),
  order_number: string,
  weight_in_ounces: string,
  tracking_number: string.isRequired,
  carrier_code: oneOf(['ups', 'usps', 'fedex']),
  tracking_url: string,
  destination: shape({
    first_name: string,
    last_name: string,
    company: string,
    address: string,
    address2: string,
    address3: string,
    city: string.isRequired,
    state: string.isRequired,
    postal_code: string.isRequired,
    phone_number: string,
    email: string,
  }),
  line_items: arrayOf(lineItemType),
});

export const carrierEventType = shape({
  occurred_at: string.isRequired,
  carrier_occurred_at: string,
  description: string.isRequired,
  city_locality: string,
  state_province: string,
  postal_code: string,
  country_code: string,
  company_name: string,
  signer: string,
  event_code: string,
});

export const trackingType = shape({
  customer_id: oneOfType([string, number]),
  carrier: oneOf(['ups', 'usps', 'fedex']),
  tracking_number: string,
  status: string,
  description: string,
  timestamp: string,
  carrier_code: oneOf(['ups', 'usps', 'fedex']),
  tracking_url: string,
  source_status_code: string,
  carrier_status_code: string,
  carrier_description: string,
  estimated_delivery_date: string,
  carrier_events: arrayOf(carrierEventType),
});

export const menuLinkType = shape({
  link: string.isRequired,
  text: string.isRequired,
});

export const socialMediaType = shape({
  type: string.isRequired,
  handle: string.isRequired,
});

export const brandingType = shape({
  logo_url: string,
  menuLinks: arrayOf(menuLinkType),
  socialMedia: arrayOf(socialMediaType),
  store_url: string,
  store_name: string,
  branded_tracking_config_id: string,
});

export const payloadType = shape({
  branding: brandingType,
  shipment: shipmentType,
  tracking: trackingType,
  carrier_tracking_url: string,
});
